import "./Lwatches.css"
import Product1 from "./Product1"

import Watchess1 from "../images/ww1.jpg"
import Watchess2 from "../images/ww2.jpg"
import Watchess3 from "../images/ww3.jpg"
import Watchess4 from "../images/ww4.jpg"
import Watchess5 from "../images/ww5.jpg"
import Watchess6 from "../images/ww6.jpg"
import Watchess7 from "../images/ww7.jpg"
import Watchess8 from "../images/ww8.jpg"
import Watchess9 from "../images/watchwadd.jpg"

export default function Lwatches() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Watchess9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="w1" prdName="TITAN" img={Watchess1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="w2"  prdName="FASTRACK" img={Watchess2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="w3" prdName="TITAN-RAGA" img={Watchess3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="w4" prdName="SONATA" img={Watchess4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="w5" prdName="G-SHOCK" img={Watchess5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="w6" prdName="TITAN" img={Watchess6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="w7" prdName="I-WATCH" img={Watchess7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="w8" prdName="REAL ME " img={Watchess8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}